import React from "react";
import { string, number, arrayOf, shape, bool } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomData from "pages/_components/CustomData/CustomData";
import { formatNum } from "util/format";

// const createListDataStructure = (data) => [
//     {
//         rowId: 1,
//         cols: [
//             {
//                 colId: 1,
//                 title: {
//                     text: "deposits.type",
//                     textType: "I18N",
//                 },
//                 value: {
//                     text: depositsTypeText[data.depositType],
//                     textType: "I18N",
//                 },
//             },
//             {
//                 colId: 2,
//                 title: {
//                     text: "deposits.accreditation",
//                     textType: "I18N",
//                 },
//                 value: {
//                     text: `${data.accreditedAccount?.productType} $ ${data.accreditedAccount?.number}`,
//                 },
//             },
//             {
//                 colId: 3,
//                 title: {
//                     text: "deposits.tnaDetail",
//                     textType: "I18N",
//                 },
//                 value: {
//                     text: data.rate,
//                     textType: "PERCENTAGE",
//                 },
//             },
//         ],
//     },
//     {
//         rowId: 2,
//         cols: [
//             {
//                 colId: 1,
//                 title: {
//                     text: "deposits.capitalInvested",
//                     textType: "I18N",
//                 },
//                 value: {
//                     text: data.amountInvested,
//                     textType: data.currency,
//                 },
//             },
//             {
//                 colId: 2,
//                 title: {
//                     text: "deposits.interest",
//                     textType: "I18N",
//                 },
//                 value: {
//                     text: data.interest,
//                     textType: data.currency,
//                 },
//             },
//             {
//                 colId: 3,
//                 title: {
//                     text: "deposits.termInDays",
//                     textType: "I18N",
//                 },
//                 value: {
//                     text: data.deadline,
//                 },
//             },
//         ],
//     },
//     {
//         rowId: 3,
//         cols: [
//             {
//                 colId: 1,
//                 title: {
//                     text: "deposits.creationDate",
//                     textType: "I18N",
//                 },
//                 value: {
//                     text: data.openDate,
//                     textType: "DATE",
//                 },
//             },
//             {
//                 colId: 2,
//                 title: {
//                     text: "deposits.expirationDate",
//                     textType: "I18N",
//                 },
//                 value: {
//                     text: data.dueDate,
//                     textType: "DATE",
//                 },
//             },
//             {
//                 colId: 3,
//                 value: {
//                     text: "",
//                 },
//             },
//         ],
//     },
// ];

const HistoricalDepositDetailList = (props) => {
    // const [newListData, setNewListData] = useState([]);

    // useEffect(() => {
    //     setNewListData(createListDataStructure(dataToList));
    // }, [dataToList]);

    const { isDesktop, deposit } = props;

    return (
        <GridTable className="deposit-details-list details">
            <GridTable.Container key={deposit.idProduct} columns={isDesktop ? 3 : 2} rows={isDesktop ? 5 : 11}>
                <GridTable.Data columnStart={1} rowStart={1}>
                    <CustomData
                        titleText="deposits.type"
                        titleTextType="I18N"
                        titleClass="text-Primary-primary-color"
                        valueText={deposit.shortLabel}
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 1 : 2}>
                    <CustomData
                        dataClass="break-all"
                        titleText="deposits.accreditation"
                        titleTextType="I18N"
                        valueText={`${deposit.accreditedAccount?.productType} $ ${deposit.accreditedAccount?.number}`}
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 1 : 3}>
                    <CustomData
                        titleText="deposits.tnaDetail"
                        titleTextType="I18N"
                        valueText={deposit.rate}
                        valueTextType="PERCENTAGE"
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={1} rowStart={isDesktop ? 2 : 4}>
                    <CustomData
                        titleText="deposits.capitalInvested"
                        titleTextType="I18N"
                        valueText={deposit.amountInvested}
                        valueTextType={deposit.currency}
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 2 : 5}>
                    <CustomData
                        titleText="deposits.interest"
                        titleTextType="I18N"
                        valueText={deposit.interest}
                        valueTextType={deposit.currency}
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 2 : 6}>
                    <CustomData titleText="deposits.termInDays" titleTextType="I18N" valueText={deposit.deadline} />
                </GridTable.Data>
                <GridTable.Data columnStart={1} columnWidth={isDesktop && 3} rowStart={isDesktop ? 3 : 7}>
                    <hr className="dotted" style={{ margin: "0" }} />
                </GridTable.Data>
                <GridTable.Data columnStart={1} rowStart={isDesktop ? 4 : 8}>
                    <CustomData
                        titleText="deposits.creationDate"
                        titleTextType="I18N"
                        valueText={deposit.openDateFormatted}
                        valueTextType="TEXT"
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 4 : 9}>
                    <CustomData
                        titleText="deposits.expirationDate"
                        titleTextType="I18N"
                        valueText={deposit.dueDateFormatted}
                        valueTextType="TEXT"
                    />
                </GridTable.Data>
                <GridTable.Data
                    columnStart={isDesktop ? 3 : 1}
                    rowStart={isDesktop ? 4 : 10}
                    alignX="flex-start"
                    alignY="flex-start">
                    <CustomData
                        titleText="deposits.iva"
                        titleTextType="I18N"
                        valueText={formatNum(deposit.vat)}
                        valueTextType={deposit.currency}
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={1} rowStart={isDesktop ? 5 : 11}>
                    <CustomData
                        titleText="deposits.retentions"
                        titleTextType="I18N"
                        valueText={formatNum(deposit.retention)}
                        valueTextType={deposit.currency}
                    />
                </GridTable.Data>
            </GridTable.Container>
        </GridTable>
    );
};

HistoricalDepositDetailList.propTypes = {
    deposit: arrayOf(
        shape({
            depositType: string.isRequired,
            accreditedAccount: string.isRequired,
            rate: number.isRequired,
            amountInvested: number.isRequired,
            interest: number.isRequired,
            deadline: number.isRequired,
            openDate: number.isRequired,
            dueDate: number.isRequired,
            currency: string.isRequired,
        }),
    ).isRequired,
    isDesktop: bool,
};

HistoricalDepositDetailList.defaultProps = { isDesktop: bool };

export default HistoricalDepositDetailList;
